import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import { convertItemsToTilesSeries, chunkArraySeries } from "../formatters/ItemFormatter";
import { dnsResolver } from "./dnsResolver"; // Import your DNS resolver

const cache = new Map<string, Promise<any>>();
const leftoverTiles = new Map<string, any[]>();

export default function (filter: string, category_id: number) {
  return async (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();
    //@ts-ignore
    const apiIdentifier = api.getIdentifier ? api.getIdentifier() : "default"; // Optional unique identifier for API instance

    const cacheKey = `${apiIdentifier}_${username}_series_${category_id}`;
    const tileKey = `${filter}_${apiIdentifier}_${username}_series_${category_id}`;

    let originalUrl = `/player_api.php?username=${username}&password=${password}&action=get_series&category_id=${category_id}`;
    let finalUrl = originalUrl;
    let hostHeader = null;

    // Check cache first
    if (cache.has(cacheKey)) {
      console.log(`💾 Using cached data for series category ${category_id}`);
      //@ts-ignore
      return cache.get(cacheKey);
    }

    // CUSTOM DNS TRANSFORMATION
    try {
      // Get the base URL from your API instance
      const baseUrl = api.baseURL || api.defaults?.baseURL || window.location.origin;
      const fullUrl = `${baseUrl}${originalUrl}`;

      console.log(`🌐 Starting DNS transformation for series category ${category_id}: ${fullUrl}`);
      console.log(`🔧 DNS Info:`, dnsResolver.getDnsInfo());

      // Apply custom DNS if enabled
      const dnsResult = await dnsResolver.transformUrl(fullUrl);
      console.log(`📡 DNS transformation result for series category ${category_id}:`, dnsResult);

      if (typeof dnsResult === "object" && dnsResult.url) {
        // Custom DNS successfully transformed the URL
        finalUrl = dnsResult.url.replace(baseUrl, ""); // Get relative path
        hostHeader = dnsResult.originalHost;
        console.log(`✅ Custom DNS applied to series category ${category_id}:`);
        console.log(`   Original: ${fullUrl}`);
        console.log(`   Transformed: ${dnsResult.url}`);
        console.log(`   Host header: ${hostHeader}`);
      } else if (typeof dnsResult === "string") {
        // URL returned as string (might be unchanged)
        if (dnsResult !== fullUrl) {
          finalUrl = dnsResult.replace(baseUrl, "");
          console.log(`🔄 Series category ${category_id} URL modified: ${dnsResult}`);
        } else {
          console.log(`📝 Series category ${category_id} URL unchanged (localhost or DNS disabled)`);
        }
      }
    } catch (dnsError) {
      console.warn(`❌ DNS transformation failed for series category ${category_id}:`, dnsError);
      finalUrl = originalUrl; // Use original URL
    }

    console.log(`📞 Making series API call for category ${category_id} with URL: ${finalUrl}`);

    // Make the API call
    const result = api
      ._get(finalUrl, {
        // Add Host header if we have one (for custom DNS)
        ...(hostHeader && { headers: { Host: hostHeader } }),
      })
      .then(series => {
        console.log(
          `✅ Series API call successful for category ${category_id}, processing ${series?.length || 0} series`,
        );
        const results = series;
        const existingTiles = leftoverTiles.get(tileKey) || [];
        const tiles = existingTiles.concat(convertItemsToTilesSeries(results));

        const chunks = chunkArraySeries(tiles);
        if (chunks[chunks.length - 1]?.length < 7) {
          leftoverTiles.set(tileKey, chunks.pop() || []);
        } else {
          leftoverTiles.delete(tileKey);
        }

        console.log(`📺 Series processed for category ${category_id}: ${tiles.length} total tiles created`);
        return tiles;
      })
      .catch(error => {
        console.error(`❌ Series API call failed for category ${category_id}:`, error);
        // Remove from cache if request fails
        cache.delete(cacheKey);
        throw error;
      });

    cache.set(cacheKey, result);
    return result;
  };
}
